import Icon from '../components/Icon.vue'

Icon.register({
  medal: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M223.8 130.8L154.6 15.5A32-32 0 0 1 127.2 0H16C3.1 0-4.5 14.6 2.9 25.2L114.2 184.1C143.9 156.4 181.7 137.3 223.8 130.8zM496 0H384.8C373.6 0 363.2 5.9 357.4 15.5L288.3 130.8C330.3 137.3 368.1 156.4 397.8 184.1L509.1 25.2C516.5 14.6 508.9 0 496 0zM256 160C158.8 160 80 238.8 80 336S158.8 512 256 512 432 433.2 432 336 353.2 160 256 160zM348.5 317.3L310.6 354.2 319.6 406.4C321.2 415.8 311.3 422.9 302.9 418.5L256 393.9 209.1 418.5C200.7 423 190.8 415.8 192.4 406.4L201.4 354.2 163.5 317.3C156.7 310.6 160.4 299 169.8 297.7L222.3 290 245.7 242.5C247.8 238.2 251.9 236.1 256 236.1 260.1 236.1 264.2 238.3 266.3 242.5L289.7 290 342.2 297.7C351.6 299 355.3 310.6 348.5 317.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/medal.js
// module id = ayvo
// module chunks = 144